import NotificationHandler from './NotificationHandler.container';
export default NotificationHandler;
